module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_16_9_w_1596.dd43e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_16_9_w_1596.jpg
// module id = PtEe
// module chunks = 0